import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
} from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function LogoutIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M4.44686 2.83569C5.36688 2.83569 16.2433 4.25983 16.2433 4.25983L13.7227 7.27196L18.8522 12.0863C19.7126 12.9274 20.2584 14.0383 20.3983 15.2334C20.5382 16.4285 20.2638 17.6354 19.6209 18.6525L18.4489 20.4926C17.5641 18.2395 16.2549 16.1772 14.5923 14.4179L10.4333 10.8008L8.08914 13.6239L4.44686 2.83569ZM4.44686 1.73929e-08C4.00218 -4.93392e-05 3.56378 0.104948 3.16737 0.306439C2.77096 0.507929 2.42775 0.800214 2.16571 1.15948C1.88585 1.52846 1.70242 1.9614 1.632 2.41911C1.56158 2.87683 1.6064 3.34488 1.76241 3.78092L5.39209 14.5313C5.55516 15.0078 5.84378 15.4314 6.22753 15.7574C6.61127 16.0835 7.07591 16.3 7.57242 16.384C7.74421 16.4017 7.91736 16.4017 8.08914 16.384C8.50549 16.3859 8.91708 16.2954 9.29415 16.1188C9.67122 15.9423 10.0044 15.6842 10.2695 15.3631L10.761 14.7834L12.6641 16.4596C14.0047 17.9283 15.0527 19.6393 15.7518 21.5008C15.939 21.9937 16.2599 22.4246 16.6784 22.7452C17.097 23.0658 17.5966 23.2633 18.1212 23.3157H18.3984C18.8691 23.3208 19.3335 23.2082 19.7495 22.9881C20.1655 22.768 20.5199 22.4473 20.7804 22.0554L21.9525 20.1649C22.9361 18.6034 23.3574 16.753 23.1465 14.9197C22.9357 13.0863 22.1054 11.3798 20.793 10.0824L17.5792 7.05771L18.3984 6.09988C18.727 5.70958 18.9456 5.23885 19.032 4.73606C19.1184 4.23327 19.0694 3.71655 18.89 3.23899C18.7049 2.76132 18.394 2.3427 17.9901 2.02759C17.5862 1.71248 17.1045 1.51266 16.5962 1.44935C13.2942 1.02085 5.48031 1.73929e-08 4.50988 1.73929e-08H4.44686Z"
          fill="url(#paint0_linear_logout)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_logout"
            x1="1.59961"
            y1="5.05644"
            x2="13.3401"
            y2="27.2804"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
